{
  "modal": {
    "buttonLabel": "选择新的时间",
    "text": "该时间刚刚被他人预订。",
    "title": "刚错过了！"
  },
  "nextLabel": "$t(common:next): <b>预留预约时间</b>",
  "nextWeek": "下周",
  "noTimeText": "所选日期暂无可用时间。",
  "prevWeek": "上周",
  "title": "请选择您的预约时间"
}
